'use client'

import Link from 'next/link'
import type { SearchAutocompletePromotion } from './searchAutocompletePromotions'

interface PromotedSearchItemProps {
  promotion: SearchAutocompletePromotion
  isActive: boolean
  onClick: () => void
  onMouseEnter: () => void
  onMouseLeave: () => void
}

const tierStyles = {
  featured: {
    badge: 'bg-vi-red/10 text-vi-red',
    active: 'bg-amber-50/90 lg:bg-amber-50/80',
    idle: 'hover:bg-amber-50/50 bg-amber-50/30',
  },
  general: {
    badge: 'bg-slate-200/90 text-slate-700',
    active: 'bg-slate-100 lg:bg-slate-50',
    idle: 'hover:bg-slate-50 bg-white',
  },
} as const

export function PromotedSearchItem({
  promotion,
  isActive,
  onClick,
  onMouseEnter,
  onMouseLeave,
}: PromotedSearchItemProps) {
  const t = tierStyles[promotion.tier]
  const badgeLabel = promotion.tier === 'featured' ? 'Featured' : 'Account'

  return (
    <Link
      href={promotion.href}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={`flex items-center gap-3 p-3 lg:p-2 border-b border-gray-100 last:border-b-0 transition-colors duration-150 touch-manipulation ${
        isActive ? t.active : t.idle
      }`}
    >
      <span
        className={`flex-shrink-0 rounded-md px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${t.badge}`}
      >
        {badgeLabel}
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-gray-900 leading-tight line-clamp-2">
          {promotion.title}
        </p>
        {promotion.subtitle && (
          <p className="mt-0.5 text-xs text-gray-600 line-clamp-1">
            {promotion.subtitle}
          </p>
        )}
      </div>
    </Link>
  )
}
